export const defaultPageSize = 30;
export const TEMP_CONTENT_ID = 9999999923000;
export const defaultCountry = 13;
